/**
 * 0..1 build/research-timer progress for a queued `TickCheckpointEvent`,
 * fed into `QueueItemCard`'s `progress` prop. Shared by ShipyardPage and
 * SciencesPage so the not-started-yet / mid-flight math lives in one place.
 */
export function eventProgress(startMs: number, endMs: number, now: number): number {
    if (now < startMs) return 0;
    const totalMs = endMs - startMs;
    if (totalMs <= 0) return 1;
    return Math.min(1, Math.max(0, (now - startMs) / totalMs));
}
